import _mitt from 'mitt';
// https://github.com/developit/mitt/issues/191
const mitt = _mitt;
export const widgetEvents = mitt();
export const useWalletManagementEvents = () => {
    return widgetEvents;
};
//# sourceMappingURL=useWalletManagementEvents.js.map